export enum ACTION_TYPE {
    ADD_ACTION = "ADD_ACTION",
    UPDATE_ACTION = "UPDATE_ACTION"
}

export enum USER_TYPE {
    ADMIN = "Admin",
    USER = "User"
}

export enum REPORT_NAME {
    // Master reports
    ORGANIZATION_MASTER = "Organization Master",
    USER_MASTER = "User Master",
    USER_GROUP = "User Group",
    USER_SUBSCRIBER = " User Subscriber",
    USER_PACKAGE = 'Package',
    RESPONSIBILITY_GROUP = 'Responsibility Group',
    RESPONSIBILITY_CENTER = 'Responsibility Center',
    TOKEN_MECHANISM_MASTER = "Token Mechanism Master",

    VALUE_CHAIN_CATEGORY = 'Value Chain Category',
    VALUE_CHAIN = 'Value Chain',
    AGENT_MASTER = "Agent Master",

    MEMBER_MASTER = "Member Master",
    MEMBER_CATEGORY_MASTER = "Member Category Master",

    ACCOUNT_MASTER = "Account Master",
    ACCOUNT_CATEGORY_MASTER = "Account Category Master",

    ACCOUNT_TYPE_MASTER = "Account Type Master",

    SCENARIO_MASTER = "Scenario Master",
    SCRIPTURAL_REFERENCE_MASTER = "Scriptural Reference Master",


    OPENING_BALANCE_MASTER_FINANCE = "Opening Balance Master - Finance",
    OPENING_BALANCE_MASTER_KARMA = "Opening Balance Master - Karma",

    VOUCHER_FINANCE = "Voucher Finance",
    VOUCHER_KARMA = "Voucher Karma",

    VOUCHER_PARTICIPANT = "Voucher Participant",
    PARTY_CATEGORY_MASTER = "Party Category Master",

    INVENTORY_CATEGORY_MASTER = "Inventory Category Master",
    INVENTORY_ITEM_MASTER = "Inventory Item Master",

    INVENTORY_OPENING_BALANCE = "Inventory Opening Balance",
    INVENTORY_TRANSACTIONS = "Inventory Transactions",

    AI_PROCESSING_LOG = "AI Processing Log",
    AUDIT_LOG = "Audit Log",

    // Common
    COUNTRY = 'Country',
    STATE = 'State',


    VOUCHER_TYPE_MASTER_FINANCE = "Voucher Type Master Finance ",
    VOUCHER_TYPE_MASTER_KARMA = "Voucher Type Master Karma",

}

export enum REPORT_PATH {

    ORGANIZATION_MASTER = "organization-master",
    RESPONSIBILITY_GROUP = 'responsibility-group',
    RESPONSIBILITY_CENTER = 'responsibility-center',

    TOKEN_MECHANISM_MASTER = "token-mechanism-master",

    //User Master report 
    USER_MASTER = "user",
    USER_GROUP = "user-group",
    USER_SUBSCRIBER = "user-subscriber",

    // Data Source Management report
    VALUE_CHAIN_CATEGORY = 'value-chain-category',
    VALUE_CHAIN = 'value-chain',
    AGENT_MASTER = "agent-master",

    MEMBER_MASTER = "member-master",
    MEMBER_CATEGORY_MASTER = "member-category",


    ACCOUNT_MASTER = "accounting-master",
    ACCOUNT_CATEGORY_MASTER = "accounting-category",

    ACCOUNT_TYPE_MASTER = "accounting-type",

    SCENARIO_MASTER = "scenario-master",
    SCRIPTURAL_REFERENCE_MASTER = "scripture-master",

    VOUCHER_TYPE_MASTER_FINANCE = "voucher-type-master-finance",
    VOUCHER_TYPE_MASTER_KARMA = "voucher-type-master-karma",

    INVENTORY_CATEGORY_MASTER_PATH = "inventory-category-master",
    INVENTORY_ITEM_MASTER_PATH = "inventory-item-master",

    INVENTORY_OPENING_BALANCE_PATH = "inventory-opening-balance",
    INVENTORY_TRANSACTIONS_PATH = "inventory-transactions",

    VOUCHER_FINANCE = "voucher-finance",
    VOUCHER_KARMA = "voucher-karma",

    VOUCHER_PARTICIPANT = "voucher-participant",
    PARTY_CATEGORY_MASTER = "party-category-master",

    OPENING_BALANCE_MASTER_FINANCE = "opening-balance-finance",
    OPENING_BALANCE_MASTER_KARMA = "opening-balance-karma",

    AI_PROCESSING_LOG = "ai-processing-log",
    AUDIT_LOG = "audit-log",


    COUNTRY = 'country',
    STATE = 'state',
}

export enum PAGE_TITLE {
    FORGOT_PASSWORD = "Forgot Password",
    RESET_PASSWORD = "Reset Password",
}

export enum TEMPLATE_FILE_NAME {
    VALUE_CHAIN_CATEGORY = 'VALUE_CHAIN_CATEGORY',
    VALUE_CHAIN = 'VALUE_CHAIN',
    RESPONSIBILITY_GROUP = 'RESPONSIBILITY_GROUP',
    RESPONSIBILITY_CENTER = 'RESPONSIBILITY_CENTER',
}